export default __webpack_public_path__ + "static/DJI_06821920px-0e31d707f1d8c7bac28e49860a507f2c.jpg";